var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.showMenu
        ? [
            _c("ul", { staticClass: "nav" }, [
              _c(
                "li",
                {
                  class: {
                    selected:
                      _vm.currentPath == "/hr/recruiter/home" ? true : false,
                  },
                },
                [
                  _c(
                    "router-link",
                    {
                      class: [_vm.lang],
                      attrs: { to: "/hr/recruiter/home?type=tab" },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("home")))]
                  ),
                ],
                1
              ),
              _c(
                "li",
                {
                  class: {
                    selected:
                      _vm.currentPath == "/hr/recruiter/campaign"
                        ? true
                        : false,
                  },
                },
                [
                  _c(
                    "router-link",
                    {
                      class: [_vm.lang],
                      attrs: { to: "/hr/recruiter/campaign" },
                    },
                    [_vm._v(_vm._s(_vm.$t("campaigns")))]
                  ),
                ],
                1
              ),
              _c(
                "li",
                {
                  class: {
                    selected:
                      _vm.currentPath == "/hr/recruiter/dashboard"
                        ? true
                        : false,
                  },
                },
                [
                  _c(
                    "router-link",
                    {
                      class: [_vm.lang],
                      attrs: { to: "/hr/recruiter/dashboard" },
                    },
                    [_vm._v(_vm._s(_vm.$t("dashboard")))]
                  ),
                ],
                1
              ),
              _c(
                "li",
                {
                  class: {
                    selected:
                      _vm.currentPath == "/hr/recruiter/linkin" ? true : false,
                  },
                },
                [
                  _c(
                    "router-link",
                    {
                      class: [_vm.lang],
                      attrs: { to: "/hr/recruiter/linkin" },
                    },
                    [_vm._v(_vm._s(_vm.$t("linkedinAccountSetting")))]
                  ),
                ],
                1
              ),
              _c(
                "li",
                {
                  class: {
                    selected:
                      _vm.currentPath == "/hr/recruiter/draft" ? true : false,
                  },
                },
                [
                  _c(
                    "router-link",
                    { class: [_vm.lang], attrs: { to: "/hr/recruiter/draft" } },
                    [_vm._v(_vm._s(_vm.$t("campaignDraft")))]
                  ),
                ],
                1
              ),
            ]),
          ]
        : [
            _c("p", { staticClass: "back" }, [
              _c(
                "span",
                { on: { click: _vm.goback } },
                [
                  _c("a-icon", { attrs: { type: "left" } }),
                  _c("span", { class: [_vm.lang] }, [
                    _vm._v(_vm._s(_vm.$t("back"))),
                  ]),
                ],
                1
              ),
            ]),
          ],
      _c(
        "keep-alive",
        [
          _c(
            "div",
            [
              _c("div", { staticStyle: { height: "50px" } }),
              _c("PostTitle", { attrs: { isSales: false } }),
            ],
            1
          ),
          _vm.$route.meta.KeepAlive
            ? _c("router-view", {
                key: _vm.$route.path,
                attrs: {
                  exclude: ["createCampaign", "/hr/recruiter/createCampaign"],
                },
              })
            : _vm._e(),
        ],
        1
      ),
      !_vm.$route.meta.KeepAlive ? _c("router-view") : _vm._e(),
      _c("PayModal", { attrs: { camp: "2" } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }